import { PCCarousel } from "@/components/Playground/Messages/PlaceholderContainer/Content/PCCarousel";

export const PlaceholderContainerContent = () => (
  <div className="flex flex-col gap-y-2">
    <PCCarousel />
  </div>
);
